export interface CustomerAgentSupplier {
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  supplierMultiLineAddress: string;
}
